<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados do Sinistro</b>
      </div>

      <div class="row g-3">
        <!-- Campo Local -->
        <div class="col-md-6" :class="getFieldValidationClass('Sinistro.SinistroMorada')">
          <label class="form-label" for="local">Local</label>
          <InputText id="local" v-model="objDTO.Sinistro.SinistroMorada" class="form-control" />
        </div>

        <!-- Campo Número -->
        <div class="col-md-6" :class="getFieldValidationClass('Sinistro.SinistroMoradaNrPorta')">
          <label class="form-label" for="numero">Nº</label>
          <InputText
            id="numero"
            v-model="objDTO.Sinistro.SinistroMoradaNrPorta"
            class="form-control"
          />
        </div>
      </div>

      <div class="row g-3 mt-3">
        <!-- Campo Complemento -->
        <div class="col-md-12">
          <label class="form-label" for="complemento">Complemento</label>
          <InputText
            id="complemento"
            v-model="objDTO.Sinistro.SinistroLocalReferencia"
            class="form-control"
          />
        </div>
      </div>

      <div class="row g-3 mt-3">
        <!-- Campo Bairro -->
        <div class="col-md-6" :class="getFieldValidationClass('Sinistro.SinistroFreguesia')">
          <label class="form-label" for="bairro">Bairro</label>
          <InputText id="bairro" v-model="objDTO.Sinistro.SinistroFreguesia" class="form-control" />
        </div>

        <!-- Campo Estimativa de Prejuízo -->
        <div class="col-md-6">
          <label class="form-label" for="estimativaPrejuizo">Estimativa de Prejuízo</label>
          <InputNumber
            id="estimativaPrejuizo"
            v-model="objDTO.Veiculo.ValorEstimadoReparacao"
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            class="form-control p-0"
          />
        </div>
      </div>

      <div class="row g-3 mt-3">
        <!-- Campo País -->
        <div class="col-md-4" :class="getFieldValidationClass('Sinistro.SinistroPaisId')">
          <label class="form-label" for="pais">País</label>
          <Dropdown
            id="pais"
            v-model="objDTO.Sinistro.SinistroPaisId"
            :options="paises"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o país"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            @change="handlePaisChange"
          />
        </div>

        <!-- Campo Estado -->
        <div class="col-md-4" :class="getFieldValidationClass('Sinistro.SinistroEstado')">
          <label class="form-label" for="estado">Estado</label>
          <Dropdown
            v-if="objDTO.Sinistro.SinistroPaisId === brasilPaisId"
            id="estado"
            v-model="objDTO.Sinistro.SinistroDistritoId"
            :options="estados"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione o estado"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingEstados"
            :disabled="
              !objDTO.Sinistro.SinistroPaisId || objDTO.Sinistro.SinistroPaisId !== brasilPaisId
            "
            @change="handleEstadoChange"
          />
          <InputText
            v-else
            id="estadoTexto"
            v-model="objDTO.Sinistro.SinistroEstado"
            class="form-control"
            placeholder="Digite o estado"
          />
        </div>

        <!-- Campo Cidade -->
        <div class="col-md-4" :class="getFieldValidationClass('Sinistro.SinistroCidade')">
          <label class="form-label" for="cidade">Cidade</label>
          <Dropdown
            v-if="objDTO.Sinistro.SinistroPaisId === brasilPaisId"
            id="cidade"
            v-model="objDTO.Sinistro.SinistroConcelhoId"
            :options="cidades"
            option-label="Description"
            option-value="Id"
            placeholder="Selecione a cidade"
            :filter="true"
            :show-clear="true"
            class="form-control w-100"
            :loading="loadingCidades"
            :disabled="!objDTO.Sinistro.SinistroDistritoId"
          />
          <InputText
            v-else
            id="cidadeTexto"
            v-model="objDTO.Sinistro.SinistroCidade"
            class="form-control"
            placeholder="Digite a cidade"
          />
        </div>
      </div>

      <div class="row g-3 mt-3">
        <!-- Campo Data do Sinistro -->
        <div class="col-md-6" :class="getFieldValidationClass('Sinistro.SinistroDataOcorrencia')">
          <label class="form-label" for="data_sinistro">Data do Sinistro</label>
          <Calendar
            id="data_sinistro"
            v-model="objDTO.Sinistro.SinistroDataOcorrencia"
            :show-icon="true"
            date-format="dd/mm/yy"
            class="form-control p-0"
            :manual-input="true"
          />
        </div>

        <!-- Campo Hora do Sinistro -->
        <div class="col-md-6" :class="getFieldValidationClass('Sinistro.SinistroHoraOcorrencia')">
          <label class="form-label" for="hora_sinistro">Hora do Sinistro</label>
          <Calendar
            id="hora_sinistro"
            v-model="horaOcorrenciaDate"
            :time-only="true"
            hour-format="24"
            :show-seconds="false"
            :manual-input="false"
            class="form-control p-0"
            @change="onHoraChange"
          />
        </div>
      </div>

      <div class="row g-3 mt-3">
        <!-- Campo Descrição da Ocorrência -->
        <div class="col-md-12" :class="getFieldValidationClass('Sinistro.SinistroObs')">
          <label class="form-label" for="descricao_ocorrencia">Descrição da Ocorrência</label>
          <Textarea
            id="descricao_ocorrencia"
            v-model="objDTO.Sinistro.SinistroObs"
            class="form-control"
            rows="4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import InputText from 'primevue/inputtext';
  import Calendar from 'primevue/calendar';
  import Textarea from 'primevue/textarea';
  import Dropdown from 'primevue/dropdown';
  import InputNumber from 'primevue/inputnumber';
  import { getDistricts, getCities as getConcelhosByDistrictId } from '../../../api/formMethods';

  export default {
    name: 'DadosSinistroTransporte',
    components: {
      InputText,
      Calendar,
      Textarea,
      Dropdown,
      InputNumber
    },
    props: {
      validation: {
        type: Object,
        default: () => ({})
      },
      events: {
        type: Array,
        default: () => []
      },
      isLoadingEvents: {
        type: Boolean,
        default: false
      },
      showCountrySelector: {
        type: Boolean,
        default: false
      },
      isLoadingData: {
        type: Boolean,
        default: false
      },
      isBrasilSelected: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        brasilPaisId: 3, // ID do Brasil na lista de países
        estados: [],
        cidades: [],
        loadingEstados: false,
        loadingCidades: false,
        horaOcorrenciaDate: null
      };
    },
    computed: {
      ...mapGetters({
        objDTO: 'getObjDTO',
        paises: 'getCountries'
      })
    },
    watch: {
      horaOcorrenciaDate(newVal) {
        if (newVal instanceof Date && !isNaN(newVal)) {
          const hh = String(newVal.getHours()).padStart(2, '0');
          const mm = String(newVal.getMinutes()).padStart(2, '0');
          this.objDTO.Sinistro.SinistroHoraOcorrencia = `${hh}:${mm}`;

          if (this.validation) {
            this.validation.$touch();
          }
        } else if (newVal === null) {
          this.objDTO.Sinistro.SinistroHoraOcorrencia = '';
        }
      }
    },
    async mounted() {
      // Inicialização de estruturas de dados para evitar erros de propriedades indefinidas
      this.initializeStructures();

      // Carregar países do store
      await this.$store.dispatch('getOrSetCountries');

      // Se já tiver um país selecionado, carregar os estados correspondentes
      if (this.objDTO?.Sinistro?.SinistroPaisId === this.brasilPaisId) {
        this.handlePaisChange();

        // Se já tiver um estado selecionado, carregar as cidades
        if (this.objDTO?.Sinistro?.SinistroDistritoId) {
          this.handleEstadoChange();
        }
      }

      // Inicializar horaOcorrenciaDate corretamente
      if (this.objDTO && this.objDTO.Sinistro && this.objDTO.Sinistro.SinistroHoraOcorrencia) {
        this.horaOcorrenciaDate = this.parseTimeToDate(this.objDTO.Sinistro.SinistroHoraOcorrencia);
      } else {
        // Se não houver hora definida, inicializa com hora atual
        const now = new Date();
        this.horaOcorrenciaDate = now;
        const hh = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        this.objDTO.Sinistro.SinistroHoraOcorrencia = `${hh}:${mm}`;

        // Forçar validação após inicializar
        this.$nextTick(() => {
          if (this.validation) {
            this.validation.$touch();
          }
        });
      }
    },
    methods: {
      // Método para obter a classe CSS de validação com base no caminho do campo
      getFieldValidationClass(fieldPath) {
        return {
          'field-required': this.isFieldInvalid(fieldPath)
        };
      },

      // Verifica se um campo específico é inválido com base no caminho
      isFieldInvalid(fieldPath) {
        if (!this.validation || !this.validation.objDTO) {
          return false;
        }

        const parts = fieldPath.split('.');
        let current = this.validation.objDTO;

        for (const part of parts) {
          if (!current[part]) {
            return false;
          }
          current = current[part];
        }

        return current.$invalid;
      },

      // Atualiza objDTO no Vuex com segurança
      updateObjDTO(path, value) {
        const newObjDTO = { ...this.objDTO };
        const parts = path.split('.');

        let current = newObjDTO;
        for (let i = 0; i < parts.length - 1; i++) {
          if (!current[parts[i]]) {
            current[parts[i]] = {};
          }
          current = current[parts[i]];
        }

        current[parts[parts.length - 1]] = value;
        this.$store.commit('setObjDTO', newObjDTO);
      },

      // Inicialização segmentada do objeto DTO
      initializeStructures() {
        this.initializeMainObject();
        this.initializeSinistro();
        this.initializeVeiculo();
        this.initializeTransporte();
      },

      // Inicializa o objeto principal
      initializeMainObject() {
        if (!this.objDTO) {
          this.$store.commit('setObjDTO', {});
        }
      },

      // Inicializa a estrutura Sinistro
      initializeSinistro() {
        if (!this.objDTO.Sinistro) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Sinistro: {
              SinistroMorada: '',
              SinistroMoradaNrPorta: '',
              SinistroLocalReferencia: '',
              SinistroDataOcorrencia: null,
              SinistroHoraOcorrencia: '00:00',
              SinistroObs: '',
              SinistroEventoId: null,
              SinistroFreguesia: '',
              SinistroPaisId: null,
              SinistroDistritoId: null,
              SinistroConcelhoId: null,
              // Campos de texto para países estrangeiros
              SinistroEstado: '',
              SinistroCidade: ''
            }
          });
          return;
        }

        // Verifica campos do Sinistro
        const sinistro = { ...this.objDTO.Sinistro };
        let isModified = false;

        // Verificar e inicializar campos
        const fieldsToCheck = [
          { name: 'SinistroEstado', defaultValue: '' },
          { name: 'SinistroCidade', defaultValue: '' }
        ];

        for (const field of fieldsToCheck) {
          if (sinistro[field.name] === undefined) {
            sinistro[field.name] = field.defaultValue;
            isModified = true;
          }
        }

        // Só atualiza o store se houver alterações
        if (isModified) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Sinistro: sinistro
          });
        }
      },

      // Inicializa a estrutura Veiculo
      initializeVeiculo() {
        if (!this.objDTO.Veiculo) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Veiculo: {
              ValorEstimadoReparacao: 0
            }
          });
          return;
        }

        if (!this.objDTO.Veiculo.ValorEstimadoReparacao) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Veiculo: {
              ...this.objDTO.Veiculo,
              ValorEstimadoReparacao: 0
            }
          });
        }
      },

      // Inicializa a estrutura Transporte
      initializeTransporte() {
        if (!this.objDTO.Transporte) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: {
              PossuiRastreador: false,
              TipoVeiculo: '',
              Motorista: {
                Nome: '',
                Telefone: '',
                CPF: '',
                CNH: ''
              },
              Veiculo: {
                Placa: '',
                Marca: '',
                Modelo: ''
              }
            }
          });
          return;
        }

        // Verifica se Motorista existe
        if (!this.objDTO.Transporte.Motorista) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: {
              ...this.objDTO.Transporte,
              Motorista: {
                Nome: '',
                Telefone: '',
                CPF: '',
                CNH: ''
              }
            }
          });
        }

        // Verifica se Veiculo existe dentro de Transporte
        if (!this.objDTO.Transporte.Veiculo) {
          this.$store.commit('setObjDTO', {
            ...this.objDTO,
            Transporte: {
              ...this.objDTO.Transporte,
              Veiculo: {
                Placa: '',
                Marca: '',
                Modelo: ''
              }
            }
          });
        }
      },

      // Método para executar funções com tratamento de erro padronizado
      async executarComTratamentoErro(funcao, params, mensagemErro) {
        try {
          return await funcao(params);
        } catch (error) {
          console.error(mensagemErro, error);
          this.$emit('erro', { mensagem: mensagemErro, detalhe: error.message });
          return [];
        }
      },

      // Função para carregar estados
      async carregarEstados() {
        this.loadingEstados = true;
        try {
          const estados = await this.executarComTratamentoErro(
            getDistricts,
            {},
            'Erro ao carregar estados'
          );
          this.estados = estados || [];
        } finally {
          this.loadingEstados = false;
        }
      },

      // Função para carregar cidades
      async carregarCidades(estadoId) {
        this.loadingCidades = true;
        try {
          const cidades = await this.executarComTratamentoErro(
            getConcelhosByDistrictId,
            estadoId,
            'Erro ao carregar cidades'
          );
          this.cidades = cidades || [];
        } finally {
          this.loadingCidades = false;
        }
      },

      async handlePaisChange() {
        // Limpa os estados e cidades ao mudar o país
        this.estados = [];
        this.cidades = [];
        this.objDTO.Sinistro.SinistroDistritoId = null;
        this.objDTO.Sinistro.SinistroConcelhoId = null;

        // Carrega estados apenas se o país for Brasil
        if (this.objDTO.Sinistro.SinistroPaisId === this.brasilPaisId) {
          await this.carregarEstados();

          // Limpa os campos de texto quando Brasil é selecionado
          this.objDTO.Sinistro.SinistroEstado = '';
          this.objDTO.Sinistro.SinistroCidade = '';
        } else {
          // Se não for Brasil, limpa os IDs dos campos
          this.objDTO.Sinistro.SinistroDistritoId = null;
          this.objDTO.Sinistro.SinistroConcelhoId = null;
        }

        // Emite evento para notificar a mudança de país
        this.$emit('paisChanged', this.objDTO.Sinistro.SinistroPaisId);
      },

      async handleEstadoChange() {
        // Limpa as cidades ao mudar o estado
        this.cidades = [];
        this.objDTO.Sinistro.SinistroConcelhoId = null;

        // Se um estado válido foi selecionado, carrega as cidades
        if (this.objDTO.Sinistro.SinistroDistritoId) {
          await this.carregarCidades(this.objDTO.Sinistro.SinistroDistritoId);
        }
      },

      parseTimeToDate(timeString) {
        if (!timeString) {
          return null;
        }

        const parts = timeString.split(':');
        if (parts.length < 2) {
          return null;
        }

        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);

        if (isNaN(hours) || isNaN(minutes)) {
          return null;
        }

        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
      },

      onHoraChange() {
        if (this.validation) {
          this.validation.$touch();
        }
      }
    }
  };
</script>

<style scoped>
  .p-dropdown {
    width: 100%;
  }
  .p-calendar {
    width: 100%;
  }
  .p-inputnumber {
    width: 100%;
  }
</style>
